// Webpack Imports
import * as bootstrap from 'bootstrap';
import './src/sticky-header';
import './src/search-overlay';

const changeImageInContainer = (src, destination, opt = {}) => {
  const template = `<img src="${src}">`;
  const container = document.querySelector(destination);
  //   console.log(`Cambiar imagen en ${destination}`);
  //   console.log(container);
  if (container) {
    const fragment = document.createRange().createContextualFragment(template);
    container.innerHTML = '';
    container.appendChild(fragment);
  }
};

window.changeImageInContainer = changeImageInContainer;

(function () {
  'use strict';

  // document
  //   .querySelector('.como-llegar-btn')
  //   .addEventListener('click', event => {
  //     var someTabTriggerEl = document.querySelector('#mapas-ubicacion-tab');
  //     var tab = new bootstrap.Tab(someTabTriggerEl);
  //     tab.show();

  //     document.querySelector('#como-llegar').scrollIntoView({
  //       behavior: 'smooth',
  //     });
  //   });

  const planeaModal = document.getElementById('planea-modal');
  //   console.log(planeaModal);
  planeaModal.addEventListener('show.bs.modal', function (event) {
    const modalTitle = planeaModal.querySelector('.modal-title');
    const modalBody = planeaModal.querySelector('.modal-body');

    modalTitle.innerHTML = '';
    modalBody.innerHTML = '';

    const modalTarget = event.relatedTarget;

    const modalTxt = document.getElementById(
      modalTarget.dataset.bsTxtContainer
    );

    if (modalTxt) {
      const modalTitleTxt = modalTxt.dataset.modalTitle;

      modalTitle.innerHTML = modalTitleTxt;
      modalBody.innerHTML = modalTxt.innerHTML;
    } else {
      const modal = bootstrap.Modal.getInstance(planeaModal);
      modal.hide();
    }
  });

  // Focus input if Searchform is empty
  [].forEach.call(document.querySelectorAll('.search-form'), el => {
    el.addEventListener('submit', function (e) {
      var search = el.querySelector('input');
      if (search.value.length < 1) {
        e.preventDefault();
        search.focus();
      }
    });
  });

  // Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
  var popoverTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="popover"]')
  );
  var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
    return new bootstrap.Popover(popoverTriggerEl, {
      trigger: 'focus',
    });
  });
})();
